import { AbstractControl } from '@angular/forms';
import { isValidBIC } from  'node_modules/ibantools';

export function bicValidator(control: AbstractControl) : { [key:string]: any} {
    const bicValue = control.value;
    return isValidBIC(bicValue) ? null : { bic: true };
}
